/* eslint-disable @typescript-eslint/naming-convention */
import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { RxStompService } from "@stomp/ng2-stompjs";
import { EventsService } from "./events.service";
import { Logger, LoggingService } from "ionic-logging-service";
import { RestolutionService } from "./restolution";

@Injectable()
export class SoftposService {

  public hostCrUuid = null; //gets value when cr is selected

  //UI mirroring related things
  public remoteHeight;
  public remoteWidth;
  public width;
  public height;
  public coefX;
  public coefY;
  public rows = 16;
  public cols = 16;
  public lastPongTime = null;
  public subs = null;

  Scroll_CMD = { c: 0xff, n: "Scroll_CMD", p: "iiiiii" };
  FillRectangle_CMD = { c: 0xfe, n: "FillRectangle_CMD", p: "iiii" };
  DrawRectangle_CMD = { c: 0xfd, n: "DrawRectangle_CMD", p: "iiii" };
  DrawString_CMD = { c: 0xfc, n: "DrawString_CMD", p: "iis" };
  DrawStringMax2_CMD = { c: 0xfb, n: "DrawStringMax2_CMD", p: "iiiss" };
  DrawStringMax_CMD = { c: 0xfa, n: "DrawStringMax_CMD", p: "iiis" };
  DrawLine_CMD = { c: 0xf9, n: "DrawLine_CMD", p: "iiii" };
  DrawStringLeft_CMD = { c: 0xf8, n: "DrawStringLeft_CMD", p: "iis" };
  DrawStringLeftDown_CMD = { c: 0xf7, n: "DrawStringLeftDown_CMD", p: "iis" };
  DrawStringLeftCenter_CMD = { c: 0xf6, n: "DrawStringLeftCenter_CMD", p: "iis" };
  SetColor_CMD = { c: 0xf5, n: "SetColor_CMD", p: "iii" };
  FontSize_CMD = { c: 0xf4, n: "FontSize_CMD", p: "i" };
  CenterText_CMD = { c: 0xf3, n: "CenterText_CMD", p: "iis" };
  TextBox_CMD = { c: 0xf2, n: "TextBox_CMD", p: "iiiis" };
  ClearScreen_CMD = { c: 0xf1, n: "ClearScreen_CMD", p: "" };
  Sound_CMD = { c: 0xf0, n: "Sound_CMD", p: "i" };
  SetBackground_CMD = { c: 0xef, n: "SetBackground_CMD", p: "iii" };
  CursorOn_CMD = { c: 0xee, n: "CursorOn_CMD", p: "ii" };
  CursorOff_CMD = { c: 0xed, n: "CursorOff_CMD", p: "" };
  XY_CMD = { c: 0xec, n: "XY_CMD", p: "ii" };
  Redraw_CMD = { c: 0xeb, n: "Redraw_CMD", p: "" };
  Key_CMD = { c: 0xea, n: "Key_CMD", p: "s" };
  Barcode_CMD = { c: 0xe9, n: "Barcode_CMD", p: "s" };
  Print_CMD = { c: 0xe8, n: "Print_CMD", p: "bii" };
  ClosePrinter_CMD = { c: 0xe7, n: "ClosePrinter_CMD", p: "" };
  Track2_CMD = { c: 0xe6, n: "Track2_CMD", p: "" };
  Fill3DRectangle_CMD = { c: 0xe5, n: "Fill3DRectangle_CMD", p: "iiii" };
  DrawBitmap_CMD = { c: 0xe4, n: "DrawBitmap_CMD", p: "iiiiii" };
  FillOval_CMD = { c: 0xe3, n: "FillOval_CMD", p: "iiii" };
  DrawStringCenter_CMD = { c: 0xe2, n: "DrawStringCenter_CMD", p: "iis" };

  DrawHtml_CMD = { c: 0xe1, n: "DrawHtml_CMD", p: "iiiiisi" };
  FillAngledOval_CMD = { c: 0xe0, n: "FillAngledOval_CMD", p: "iiiii" };
  FillAngledRectangle_CMD = { c: 0xdf, n: "FillAngledRectangle_CMD", p: "iiiii" };
  Logout_CMD = { c: 0xde, n: "Logout_CMD", p: "" };
  DrawStringCenterRotated_CMD = { c: 0xdd, n: "DrawStringCenterRotated_CMD", p: "iis" };
  DrawImage_CMD = { c: 0xdc, n: "DrawImage_CMD", p: "siiiiii" };
  ShowImage_CMD = { c: 0xdb, n: "ShowImage_CMD", p: "s" };
  UnshowImage_CMD = { c: 0xda, n: "UnshowImage_CMD", p: "" };
  TurnDisplayOn_CMD = { c: 0xd9, n: "TurnDisplayOn_CMD", p: "" };
  Drag_CMD = { c: 0xd8, n: "Drag_CMD", p: "ii" };
  MousePressed_CMD = { c: 0xd7, n: "MousePressed_CMD", p: "ii" };
  Play_CMD = { c: 0xd6, n: "Play_CMD", p: "s" };
  SetGradient_CMD = { c: 0xd5, n: "SetGradient_CMD", p: "iii" };
  SendToBack_CMD = { c: 0xd4, n: "SendToBack_CMD", p: "" };
  DrawStringCenterDown_CMD = { c: 0xd3, n: "DrawStringCenterDown_CMD", p: "iis" };
  FontStyle_CMD = { c: 0xd2, n: "FontStyle_CMD", p: "i" };
  DummyCommand_CMD = { c: 0xcf, n: "DummyCommand_CMD", p: "siiiis" };

  all_commands = [
    this.Scroll_CMD, this.FillRectangle_CMD, this.DrawRectangle_CMD, this.DrawString_CMD,
    this.DrawStringMax2_CMD, this.DrawStringMax_CMD, this.DrawLine_CMD, this.DrawStringLeft_CMD, this.DrawStringLeftDown_CMD,
    this.DrawStringLeftCenter_CMD, this.SetColor_CMD, this.FontSize_CMD, this.CenterText_CMD, this.TextBox_CMD,
    this.ClearScreen_CMD, this.Sound_CMD, this.SetBackground_CMD, this.CursorOn_CMD, this.CursorOff_CMD, this.XY_CMD, this.Redraw_CMD,
    this.Key_CMD, this.Barcode_CMD, this.Print_CMD, this.ClosePrinter_CMD, this.Track2_CMD, this.Fill3DRectangle_CMD,
    this.DrawBitmap_CMD, this.FillOval_CMD, this.DrawStringCenter_CMD, this.DrawHtml_CMD, this.FillAngledOval_CMD,
    this.FillAngledRectangle_CMD, this.Logout_CMD, this.DrawStringCenterRotated_CMD, this.DrawImage_CMD, this.ShowImage_CMD,
    this.UnshowImage_CMD, this.TurnDisplayOn_CMD, this.Drag_CMD, this.MousePressed_CMD, this.Play_CMD, this.SetGradient_CMD,
    this.SendToBack_CMD, this.DrawStringCenterDown_CMD, this.FontStyle_CMD, this.DummyCommand_CMD];

  STRING_CMD = 0xc0;
  INT_CMD = 0xc1;
  LONG_STRING_CMD = 0xc2;
  LIMIT_CMD = 0xc0;

  private logger: Logger;

  constructor(private http: HttpClient, @Inject("remoteStomp") private stomp: RxStompService,
    public events: EventsService, private loggingService: LoggingService) {
      this.logger = loggingService.getLogger("BestoGo.SoftposService");
  }

  public endListeningForUiChanges() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  public startListeningForUiChanges() {
    this.endListeningForUiChanges();
    const uiFn = (data) => {
     this.logger.debug("startListeningForUiChanges", "Got data", data);
      if (data.type && data.type === "params") {
        this.remoteHeight = data.h;
        this.remoteWidth = data.w;
        this.rows = data.r;
        this.cols = data.c;
        this.eventsPublish("ui.command.params", data);
        return;
      } else if (data.type === "pong") {
        this.lastPongTime = new Date().getTime();
      } else if (data.type && data.type === "edit") {
        const editParams = {
          type: data.t,
          value: data.v
        };
        this.eventsPublish("ui.command.edit", editParams);
        return;
      } else if (data.type && data.type === "file") {
        const fileParams = {
          data: atob(data.b),
          name: data.n
        };
        this.eventsPublish("ui.command.file", fileParams);
        return;
      } else if (data.type && data.type === "receipt_html") {
        const fileParams = {
          data: atob(data.b),
          name: data.n
        };
        this.eventsPublish("ui.command.receipt_html", fileParams);
        return;

      } else if (data.type && data.type === "receipt_txt") {
        const fileParams = {
          data: atob(data.b),
          name: data.n
        };
        this.eventsPublish("ui.command.receipt_txt", fileParams);
        return;

      } else if (data.type && data.type === "bin") {
        const bytes = atob(data.b);
        const stack = [];
        for (let i = 0; i < bytes.length; i++) {
          const b = bytes.charCodeAt(i);
          if (b < this.LIMIT_CMD) {
            stack.push(b);
            continue;
          } else if (b === this.INT_CMD) {
            const b1 = bytes.charCodeAt(++i);
            const b2 = bytes.charCodeAt(++i);
            const int2 = (b1 << 8 | b2);
            //console.log("got int", int2, int2.toString(16));
            stack.push(int2);
            continue;
          } else if (b === this.STRING_CMD || b === this.LONG_STRING_CMD) {
            const l = bytes.charCodeAt(++i);
            let str = "";
            for (let j = 1; j < l + 1; j++) {
              str = str + bytes.charAt(i + j);
            }
            i = i + l;
            stack.push(str);
            continue;
          }
          for (const command of this.all_commands) {
            if (command.c === b) {
              const pparams = [];
              for (let j = 0; j < command.p.length; j++) {
                pparams.push(stack.pop());
              }
              this.eventsPublish("ui.command", { c: command, p: JSON.stringify(pparams) });
              break;
            }
          }
        }
      }
    };
    this.subs = this.stomp.watch("/topic/cr." + this.hostCrUuid + ".visual").subscribe((msg) => {
      this.logger.debug("startListeningForUiChanges", "Found msg2: ", msg, JSON.parse(msg.body));
      uiFn(JSON.parse(msg.body));
    });
  }

  public socketSendToUi(touchCmd: { x?: number; y?: number; type: string }) {
    this.stomp.publish({ destination: "/topic/cr." + this.hostCrUuid + ".control.ui", body: JSON.stringify(touchCmd) });
  }

  public setScreenCoefs(width, height) {
    this.height = height;
    this.width = width;
    this.coefX = this.width / this.cols;
    this.coefY = this.height / this.rows;
    this.logger.trace("setScreenCoefs", "size", this.height, this.width);
  }


  private eventsPublish(params: string, data) {
    this.events.publishEvent({
      type: params,
      data
    });
  }



}
